import React, { useState } from 'react'
import './dealershipsinsurance.scss'
import { Hero, MainHeading, Breadcrumb, PageHeaderIntro, FindAgent, CommonTabs, FigureCards, NewsCard, Faq, SuccessStories, CommonBlueCards } from '../../../components';
import { images } from "../../../utils/customFn";
import { Row, Col, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const DealershipsInsurance = () => {
  const [hrefData, setHrefData] = useState();
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "Who we serve", link: "/who-we-serve/" },
    { label: "Dealerships", link: "/whoweserve/dealershipsinsurance" },
  ];

  const HeaderData = [
    {
      image: images['Working_Computers_Blue.svg'],
      para: 'You know the hard work it takes to make your dealership a success. Regardless of what’s for sale on your lot, we’re ready to help you protect it. From property to auto or even a retirement plan, we’ll put our insights and experience to work for you. We’ll even show you how to manage the pitfalls that could cause a claim. It’s all about providing the coverage you need, the right business insurance solutions, and risk management programs for you.',
    },
  ];

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const ProductCardData = [
    {
      id: 1,
      title: 'Farm equipment dealerships',
      description:
        'Protection for those who supply American farmers with the equipment they need to keep growing.',
      linkUrl: '',
      linkText: 'Farm equipment dealerships  >',
    },
    {
      id: 2,
      title: 'Auto dealerships',
      description:
        'Protection for your lot, your sales and service staff, and your customers.',
      linkUrl: '/',
      linkText: 'Auto dealerships >',
    },
    {
      id: 3,
      title: 'Boat dealerships',
      description:
        'From bass boats to pontoons, we’ll help protect the business that keeps you afloat.',
      linkUrl: '/',
      linkText: 'Boat dealerships >',
    },
  ];

  const ResourceData = [
    {
      id: 1,
      title: 'Dealership resources',
      description:
        'Explore our resources featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
      linkUrl: '',
      linkText: 'View resources >',
    },
    {
      id: 2,
      title: '2024 Dealership Injury Report',
      description:
        'Discover the latest trends, risks, and costs involving workplace injuries in the dealership industry.',
      linkUrl: '/',
      linkText: 'Download report >',
    },
  ];

  const tabsData = [
    {
      id: "thesentry",
      href: "theSentry",
      label: "The Sentry difference",
    },
    {
      id: "weserve",
      href: "weserve",
      label: "Types of dealerships we serve",
    },
  ];
  const activeTabId = "thesentry";
  return (
    <>
      <div className='dealership-main'>
        {/* hero section */}
        <Hero img={images["Dealerships-Hero.avif"]} />
        <Container>
          {/* Breadcrumb */}
          <Breadcrumb crumbs={breadcrumbs} />

          {/* heading  */}
          <MainHeading title="Insurance for dealerships" showshare={false} />

          {/* tabs */}
          <CommonTabs tabs={tabsData} activeTab={activeTabId} hrefData={hrefData}
            setHrefData={setHrefData} />

          {/* page intro */}
          <PageHeaderIntro Data={HeaderData} />

          <div className='the-sentry' id='theSentry'>
            <Row className='g-0'>
              <Col sm={12} md={5} lg={4} xl={4}>
                <div className='img-wrapper'>
                  <img src={images['Dealerships-SentryDifference.avif']} alt="img" />
                </div>
              </Col>
              <Col sm={12} md={7} lg={8} xl={8}>
                <div className='details-section'>
                  <h1>The Sentry difference</h1>
                  <h2>Minimizing risks</h2>
                  <p>We offer you more than specially designed insurance for dealerships. Our safety program will help you control risks at your dealership. You’ll have access to safety resources online 24/7. And our knowledgeable safety staff will work with you to help your employees stay safe and avoid the pitfalls that can lead to a claim.</p>
                  <div className='trust-bottom'>
                    <img src={images['birds_Blue.svg']} alt="icon" />
                    <div className='text'>
                      <h3>Trusted by dealers since 1969</h3>
                      <p>We protect more than 2,000 dealers nationwide.</p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {/* dealerships we serve */}
          <NewsCard id="weserve" Title="Types of dealerships we serve" CardData={ProductCardData} showNavLink={false} subTitle=" " />

          {/* common blue cards  */}
          <div className='feature-banner-row'>
            <Row className='g-0'>
              <Col sm={12} md={5} lg={5} xl={5}>
                <div className='details-section'>
                  <h2>Sentry Risk Factor</h2>
                  <p>How does your dealership’s risk management program stack up? Find out with our risk assessment tool.</p>
                  <NavLink to='#/'>Get started</NavLink>
                </div>
              </Col>
              <Col sm={12} md={7} lg={7} xl={7}>
                <div className='img-wrapper'>
                  <img src={images['Two_Business_Men-Talking.avif']} alt="img" />
                </div>
              </Col>
            </Row>
          </div>

          {/* stories */}
          <SuccessStories />

          {/* common blue cards  */}
          <CommonBlueCards CardData={ResourceData} Title="Related resources" />

          {/* find agent */}
          <FindAgent options={Selectoptions} />
        </Container>
      </div>
    </>
  )
}

export default DealershipsInsurance